/* unplugin-vue-components disabled */import { render } from "./LoginView.vue?vue&type=template&id=d7a2c380&scoped=true&ts=true"
import script from "./LoginView.vue?vue&type=script&lang=ts"
export * from "./LoginView.vue?vue&type=script&lang=ts"

import "./LoginView.vue?vue&type=style&index=0&id=d7a2c380&lang=scss&scoped=true"

import exportComponent from "D:\\openclawprogram\\sdjk123-vue - Copy - Copy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7a2c380"]])

export default __exports__